module.exports = __webpack_public_path__ + "b4b7581051f65ba70a098fa203b7020e.jpg";